(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("HeaderAlarmsViewModel", headerAlarmsViewModelFactory);

  /** @ngInject */
  function headerAlarmsViewModelFactory(messagesStore, MessageTypeEnum) {
    function HeaderAlarmsViewModel() {
      this.alarms = [];
      this._messagesStoreChangeHandler = null;
      this._messagesStoreChangeKarcherHandler = null;

      init.call(this);
    }

    HeaderAlarmsViewModel.prototype.destroy = function() {
      messagesStore.off(
        messagesStore.events.CHANGE,
        this._messagesStoreChangeHandler
      );
    };

    return HeaderAlarmsViewModel;

    function init() {
      var that = this;

      refresh.call(that);

      this._messagesStoreChangeHandler = function() {
        refresh.call(that);
      };

      messagesStore.on(
        messagesStore.events.CHANGE,
        this._messagesStoreChangeHandler
      );
    }

    function refresh() {
      var that = this;
      var messagesData = messagesStore.getMessages();
      that.alarms = [];
      if (messagesData !== null) {
        messagesData.forEach(function(message) {
          if (message.collapseKey === MessageTypeEnum.ALARM) {
            that.alarms.push({
              deviceSerial: message.device,
              message: message.content,
              time: moment(message.timestamp).fromNow(),
              location: message.details
            });
          }
        });
      }
    }
  }
})();
